import dayjs from 'dayjs';

import { useIsImpersonating, useUser } from '~/api/user';

import { Nps } from './Nps/Nps';
import { VerifyAddress } from './VerifyAddressModal/VerifyAddress';

export const Prompts = () => {
  const { data: user } = useUser();
  const isImpersonating = useIsImpersonating();

  if (isImpersonating) return null;

  // Prompt address verification after November 1st
  const firstOfNovember = dayjs().month(10).date(1).startOf('day');
  const addressVerificationDate = firstOfNovember.isAfter(dayjs()) ? firstOfNovember.subtract(1, 'year') : firstOfNovember;

  if (dayjs(user.appSettings.addressLastVerifiedAt).isBefore(addressVerificationDate)) return <VerifyAddress />;

  if (user.showNps) return <Nps />;

  return null;
};
